/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { JoinLogDto } from '../../models/join-log-dto';

export interface CenterJoinLogControllerRejectJoinRequest$Params {

/**
 * 가입 요청 ID
 */
  joinId: string;

/**
 * 센터 ID
 */
  centerId: string;

/**
 * 센터 ID
 */
  id: any;
}

export function centerJoinLogControllerRejectJoinRequest(http: HttpClient, rootUrl: string, params: CenterJoinLogControllerRejectJoinRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<JoinLogDto>> {
  const rb = new RequestBuilder(rootUrl, centerJoinLogControllerRejectJoinRequest.PATH, 'patch');
  if (params) {
    rb.path('joinId', params.joinId, {});
    rb.query('centerId', params.centerId, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<JoinLogDto>;
    })
  );
}

centerJoinLogControllerRejectJoinRequest.PATH = '/api/center-join-log/{id}/join/{joinId}/reject';
